import { driver, DriveStep } from 'driver.js'
import 'driver.js/dist/driver.css'
import '@/utils/manual/tour-overrides.css'

import { tourPopoverClass } from '@/utils/manual/tour-colors'
import { ScreenTourManual } from '@/utils/manual/types'

/**
 * data-manual 属性セレクタを組み立てる
 */
function toSelector(target?: string): string | undefined {
  if (!target) {
    return undefined
  }
  return `[data-manual="${target}"]`
}

/**
 * 画面ツアーステップを driver.js で開始する
 */
export function startScreenTour(manual: ScreenTourManual): void {
  const steps: DriveStep[] = (manual.steps || []).map((step) => {
    const element = toSelector(step.target)
    const popover = {
      title: step.title,
      description: step.body,
      side: 'bottom' as const,
      align: 'start' as const,
    }
    if (element) {
      return { element, popover }
    }
    return { popover }
  })

  if (steps.length === 0) {
    return
  }

  const d = driver({
    showProgress: true,
    animate: true,
    allowClose: true,
    popoverClass: tourPopoverClass(),
    overlayColor: 'rgb(15, 23, 42)',
    overlayOpacity: 0.45,
    nextBtnText: '次へ',
    prevBtnText: '戻る',
    doneBtnText: '閉じる',
    progressText: '{{current}} / {{total}}',
    steps,
  })

  d.drive()
}
